module.exports = __webpack_public_path__ + "static/media/Primate-House9.b2b2307f.jpg";